// extracted by mini-css-extract-plugin
export default {"load":"style_load__3C+YF","load_text":"style_load_text__lZmvq","load_logo":"style_load_logo__-Fdp1"};